import React, { Component } from 'react';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import * as Utils from '../../common/utilSvc';
import * as CoreHelper from '../../common/coreHelper';
import { isNullOrUndefined } from "util";
import './publicInspireBot.css';
import IndividualPoint from './individualPoint/individualPoint';
import firebase from "firebase/app";
import "firebase/analytics";

class PublicInspireBot extends React.Component {

    constructor(props){
        super(props);

        this.state = {
            content: "",
            currPoints: [],
            iconListMap: {}
        }

        this.canSave = this.canSave.bind(this);
        this.findIcons = this.findIcons.bind(this);
        this.getPoints = this.getPoints.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.searchIconWrapper = this.searchIconWrapper.bind(this);
    }

    canSave(){
        if(this.state.content.trim().length>0)
            return true;
        return false;
    }

    getPoints(text){
        let output = []
        if(!isNullOrUndefined(text)){
            output = text.split("\n");
        }
        return output;
    }

    async searchIconWrapper(query){
        let iconListMap = this.state.iconListMap;
        if(iconListMap[query] && iconListMap[query].length>0)
            return;

        let output = [];
        output = await CoreHelper.searchIconsFromKeywords(query);

        if(isNullOrUndefined(output) || output.length<3){
            let synonyms = [];
            synonyms = await CoreHelper.getWordSynonyms(query);
            // console.log(synonyms);

            for(let i=0;!isNullOrUndefined(synonyms) && i<synonyms.length; i++){
                let synonymWord = synonyms[i];
                let newOutput = await CoreHelper.searchIconsFromKeywords(synonymWord);

                if(!isNullOrUndefined(newOutput)){
                    for(let j=0;j<=Math.min(2,newOutput.length); j++){
                        if(!isNullOrUndefined(newOutput[j]))
                            output.push(newOutput[j]);
                    }
                }

                // console.log(synonymWord, newOutput);
                 if(!isNullOrUndefined(output) && output.length>3)
                    break;
            }
        }

        if(!isNullOrUndefined(output) && output.length>0){
            for(let i=0; i<output.length; i++){
                // console.log(output[i]);
                output[i]['query'] = query;
            }
        }

        iconListMap[query] = output;

        // console.log(iconListMap)

        this.setState({iconListMap: iconListMap});

        firebase.analytics().logEvent('icon_search',{
            name: query
        });

    }

    async findIcons(){
        //find icons here

        //Get points
        let points = this.getPoints(this.state.content);
        // console.log(points);

        let entitiesPromise = [];
        for(let i=0; i<points.length; i++){
            let pointEntities = CoreHelper.googleNlpEntityExtraction(points[i]);
            entitiesPromise.push(pointEntities);           
        }

        let entities =  await Promise.all(entitiesPromise);
        // console.log(entities);

        let currPoints = [];

        for(let i=0; i<points.length; i++){
            let newPoint = {};
            newPoint["text"] = points[i];
            newPoint["keywords"] = CoreHelper.pointsEntityAlgo(entities[i]);
            if(newPoint["keywords"] && newPoint["keywords"].length>0){
                for(let j=0; j<newPoint["keywords"].length; j++){
                    this.searchIconWrapper(newPoint["keywords"][j]["name"]);
                }
            }
            currPoints.push(newPoint);
        }

        // console.log(currPoints);

        this.setState({
            currPoints: currPoints
        });

        /*
            Getting icons. Here, you need to ensure that the words are broken 
            Sales executives = "Sales" is separate word and "executives" is separate word
            At times, it is single word, like "artificial intelligence", so keep that also
        */

        firebase.analytics().logEvent('general_logs',{
            name: 'search_button_clicked'
        });

    }

    handleChange(event, type, index){
        if(type=="content"){
            let content = this.state.content;
            content = event.target.value;
            content = Utils.cleanString(content);
            this.setState({content: content});            
        }
    }

    componentDidMount(){
        // this.searchIconWrapper("meeting");
    }

    render(){

        let scope = this;

        const pointsRender = this.state.currPoints.map((point) => 
                    { 
                        return (
                        <IndividualPoint 
                            point = {point}
                            iconListMap = {this.state.iconListMap}
                            />
                        )
                    });
        return (
            <div>
                <h1>Inspire Bot</h1>
                <div style={{margin:'10px', textAlign:'center', fontSize:'12px'}}>
                    <form>
                        <label>
                            <TextField 
                                type="text"
                                variant="outlined"
                                multiline
                                label = "Copy paste bullet points"
                                placeholder = "Copy paste content here"
                                value={this.state.content}
                                onChange={(e) => { this.handleChange(e,"content")}}
                                rowsMax="10"
                                rows="5"
                                style={{
                                    background: 'white',
                                    width:'80vw',
                                    minWidth: '250px'
                                    }}/>
                        </label>
                    </form>
                    <div style={{margin:'1em'}}>
                        <div style={{display:'flex', justifyContent:'center'}}>
                            {this.canSave()?
                                <div>
                                    <Button
                                    color="primary"
                                    variant="contained"
                                    onClick={() => {this.findIcons()}}>
                                        Click me!
                                    </Button>
                                </div>
                                :
                                null
                            }
                        </div>
                    </div>
                </div>
                <div style={{margin:'1em', textAlign:'left'}}>
                    {pointsRender}
                </div>
            </div>
        )
    }

}
export default PublicInspireBot;
